import { Component } from '@theme/component';
import { mediaQueryLarge } from '@theme/utilities';

export class QuickCustomizeComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    // Add click handler to the button
    this.button = this.querySelector('.quick-customize__button');
    if (this.button) {
      this.button.addEventListener('click', this.handleClick);
    }
    
    mediaQueryLarge.addEventListener('change', this.#closeIfNeeded);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    
    // Remove click handler
    if (this.button) {
      this.button.removeEventListener('click', this.handleClick);
    }
    
    mediaQueryLarge.removeEventListener('change', this.#closeIfNeeded);
  }

  /**
   * Handles customize button click - opens the bookery configurator app
   * @param {Event} event - The click event
   */
  handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const productId = this.dataset.productId;

    console.log('Opening HB Customizer for product:', productId);

    // Check if we're on the product page or collection page
    const modal = document.querySelector('#bookery-modal');
    
    if (modal) {
      // We're on the product page, open the modal directly
      modal.classList.add('bookery-modal--open');
      document.body.style.overflow = 'hidden';
    } else {
      // We're on a collection page, navigate to product page and open modal
      // Set flag in localStorage to open configurator on page load
      localStorage.setItem('hb-open-customizer', productId);
      
      // Find the product link - try multiple approaches
      let productUrl = null;
      
      // Try to find the closest product card wrapper
      const productCard = this.closest('product-card, .product-card, .card, [class*="product"]');
      
      if (productCard) {
        // Look for any link within the product card
        const link = productCard.querySelector('a[href*="/products/"]');
        if (link) {
          productUrl = link.href;
        }
      }
      
      // Fallback: look for any parent link
      if (!productUrl) {
        const parentLink = this.closest('a[href*="/products/"]');
        if (parentLink) {
          productUrl = parentLink.href;
        }
      }
      
      console.log('Product URL:', productUrl);
      
      if (productUrl) {
        window.location.href = productUrl;
      } else {
        console.error('Could not find product link');
        alert('Could not find product page. Please try clicking the product image instead.');
      }
    }
  };

  #closeIfNeeded = () => {
    if (mediaQueryLarge.matches) {
      this.toggleAttribute('stay-visible', false);
    }
  };
}

if (!customElements.get('quick-customize-component')) {
  customElements.define('quick-customize-component', QuickCustomizeComponent);
}
